import { Component, OnInit, Injector } from '@angular/core';
import {  Observable } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  combineLatest,
  map,
  mergeMap,
  tap
} from 'rxjs/operators';
import {
  IFilterComboComponent,
  IFilterTextComponent,
  LoggedComponent,
  LoggerService,
  RankingItem,
  RankSortingTypeEnum,
  ViewDataInterface,
  ViewDataService,
  WCupRankingLocator
} from 'world-archery-lib';
import { FilterWCupRankingService } from '../../services/filter-wcup-ranking.service';
import { TableAbstractComponent } from '../../../../common-page-components/classes/table-abstract-component';
import { WcupRankingStore } from 'src/app/common-page-components/stores/entities-store/wcup-ranking-store';
import { HttpClient } from '@angular/common/http';
import { CountryDependencyEntityStore } from 'src/app/common-page-components/stores/entities-store/country-dependency-entity-store';

@Component({
  selector: 'app-wcup-rannking-list',
  templateUrl: './wcup-rannking-list.component.html',
  styleUrls: ['./wcup-rannking-list.component.scss']
})
export class WCupRannkingListComponent extends TableAbstractComponent
  implements OnInit {
  RankingView: ViewDataInterface;
  RankingsList: Array<RankingItem> = [];
  constructor(
    injector:Injector,
    public filter_service: FilterWCupRankingService,
    http:HttpClient
  ) {
    super(injector, filter_service, new WcupRankingStore(http, [{entity:new CountryDependencyEntityStore(http, injector)}]));
  }

  ngOnInit() {
    this.getDataStream().subscribe();
  }
  getDataStream(): Observable<any> {
    return  this.filter_service.getDataStreamWithFilters().pipe(
      combineLatest([this.reload.asObservable()]),
      map(([a, b]) => a),
      map(([order, textFilter, category, season, country]) => {
        const params = {
          fText: textFilter,
          SortBy: order.sortingSend,
          Year : season.year,
          Detailed: true,
          Team : category.isTeam,
          CatCode: category.code,
          Country: country.NOC,
          DisciplineId: 1
        }
        this.filter_service.sortLocator.sortingType = order ? order.sortingType : 'RANKING' as any;
        this.filter_service.sortLocator.asc = order ? order.asc : true;

        return params;
      }),  mergeMap(params => this.model.requestData(params, this.request_more_data)
    ));
  }
  changeSort(category: string
  ) {
    if (category === 'RANKING') {
      this.filter_service.sortLocator.asc = !this.filter_service.sortLocator.asc;
      this.filter_service.sortLocator.sortingType = category as any;
      this.filter_service.modifyOrderValue();
      return;
    }
    if (category === undefined) {
      this.filter_service.sortLocator.sortingType = undefined;
      this.filter_service.sortLocator.asc = true;
    } else {
      if (category === this.filter_service.sortLocator.sortingType) {
        if (this.filter_service.sortLocator.asc === false) {
          this.filter_service.sortLocator.sortingType = undefined;
        }
        this.filter_service.sortLocator.asc = !this.filter_service.sortLocator
          .asc;
      } else {
        this.filter_service.sortLocator.sortingType = category as any;
        this.filter_service.sortLocator.asc = true;
      }
    }
    this.filter_service.modifyOrderValue();
  }
  rankingSort() {
    if (
      this.filter_service.sortLocator.sortingType === undefined) {
      return 'asc';
    } else {
      if (this.filter_service.sortLocator.sortingType === 'RANKING' &&
        this.filter_service.sortLocator.asc === false) {
        return 'desc';
      }
      if (this.filter_service.sortLocator.sortingType === 'RANKING' &&
        this.filter_service.sortLocator.asc === true) {
        return 'asc';
      }
    }
  }
  sortClass(category: string
  ) {
    if (this.filter_service.sortLocator.sortingType !== category) {
      return '';
    }
    return this.filter_service.sortLocator.asc === true ? 'asc' : 'desc';
  }
  get defaultValueMessage() {
    return (<IFilterComboComponent>(
      this.filter_service.filtersType[2].options
    )).options_selected_subject
      .asObservable()
      .pipe(
        // filter(category => category !== undefined)
        map(a => {
          if (a === undefined) {
            return 'adjust_parameters';
          } else {
            return '';
          }
        })
      );
  }
}
